module.exports = __webpack_public_path__ + "static/media/fish-cake.abc16131.jpg";